import socketio from 'socket.io-client';
import semver from 'semver';
import store from './store';

const websocket = socketio('/dashboard', { autoConnect: !!store.state.auth.token, transports: ['polling'] });

websocket.on('connect_error', (err) => {
  console.log(`connect_error due to ${err.message}`);
});

websocket.once('connect', () => {
  const { token } = store.state.auth;
  if (token) {
    const { user } = token;

    websocket.emit('dashboard/identity', user);

    store.commit('setBusy', true);
    store.dispatch('getFavorites')
      .then(() => store.dispatch('getLatestSoftwareVersion'))
      .then(() => store.dispatch('getServiceStatus'))
      .then(() => store.dispatch('getLatestGtpsSoftwareVersion'))
      .then(() => store.dispatch('getLatestOasisSoftwareVersion'))
      .then(() => store.dispatch('getStagedUpdateTotals'))
      .then(() => store.dispatch('getStagedGtpsUpdateTotals'))
      .then(() => store.dispatch('getStagedOasisUpdateTotals'))
      .then(() => store.dispatch('getAlignerSoftwareVersions'))
      .then(() => store.dispatch('getSupportTicketStatistics'))
      .then(() => store.dispatch('getGtpsSoftwareVersions'))
      .then(() => store.dispatch('getOasisSoftwareVersions'))
      .then(() => store.dispatch('getSpecVersions'))
      // .then(() => {
      //  return store.dispatch('getTop10Aligners');
      // })
      .then(() => {
        store.commit('setBusy', false);
      });
  } else {
    console.warn('socket disconnecting; not authorized');
    websocket.disconnect();
  }
});

websocket.on('SERVICE_STATUS', (data) => {
  store.dispatch('updateServiceStatus', data);
})

websocket.on('RADAR_UPDATE_FAVORITE', (data) => {
  //console.log('RADAR_UPDATE_FAVORITE');
  store.dispatch('updateFavorite', data);
});

websocket.on('RADAR_ADD_FAVORITE', (data) => {
  //console.log('RADAR_ADD_FAVORITE');
  store.dispatch('addFavorite', data.serialNumber);
});

websocket.on('RADAR_REMOVE_FAVORITE', (data) => {
  //console.log('RADAR_REMOVE_FAVORITE');
  store.dispatch('removeFavorite', data.serialNumber);
});

websocket.on('REPORT_SUPPORT_TICKET_CLOSED', (data) => {
  store.commit('setAlertText', `Support ticket ${data.id} for aligner ${data.serialNumber} closed by ${data.closedBy}.`);
});

websocket.on('REPORT_SUPPORT_TICKET_COMMENT_CREATED', (data) => {
  store.commit('setAlertText', `Comment on ticket ${data.id} for aligner ${data.serialNumber} created by ${data.author}.`);
});

websocket.on('REPORT_SUPPORT_TICKET_CREATED', (data) => {
  store.commit('setAlertText', `New ticket ${data.id} for aligner ${data.serialNumber} created by ${data.openedBy}.`);
});

websocket.on('NEW_SOFTWARE_UPDATE_CREATED', (data) => {
  console.log('****************** NEW_SOFTWARE_UPDATE_CREATED');
  if (semver.gt(data.version.semantic, store.state.latestSoftwareVersion.semantic)) {
    store.commit('setAlertText', `The latest software available is now version ${data.version.semantic}.`);
    store.commit('setLatestSoftwareVersion', data.version);
  }
});

websocket.on('NEW_SOFTWARE_UPDATE_SCHEDULE_CREATED', (data) => {
  console.log('****************** NEW_SOFTWARE_UPDATE_SCHEDULE_CREATED');
});

websocket.on('SOFTWARE_UPDATES_STAGED', (data) => {
  console.log('****************** SOFTWARE_UPDATES_STAGED');
  store.dispatch('getStagedUpdateTotals');
});

websocket.on('CONNECTION_COUNTERS', (data) => {
  // console.log('****************** CONNECTION_COUNTERS');
  store.commit('setConnectionCounters', data);
});

websocket.on('SUPPORT_TICKET_STATISTICS', (data) => {
  store.commit('setSupportTicketStatistics', data);
});

export default websocket;
